export default __webpack_public_path__ + "static/media/wastebasket.b7e833c3.svg";